import {type ReactNode} from "react";
import {useCombatants} from "./combatants/CombatantHooks.ts";
import {useTurn} from "./turns/TurnHooks.ts";
import {useAreaEffect} from "./effect/AreaEffectHooks.ts";
import {useDoorStates} from "./doors/DoorStateHooks.ts";
import {useEncounterLights} from "./lights/EncounterLightHooks.ts";
import InitialLoadReady from "@/components/loading/InitialLoadReady.tsx";

/** These providers load in parallel; their consumers mount after the last one is ready. */
export default function EncounterReadyGate({children}: {children: ReactNode}) {
    const combatants = useCombatants();
    const turn = useTurn();
    const effects = useAreaEffect();
    const doors = useDoorStates();
    const lights = useEncounterLights();

    if (combatants.initialLoading || turn.initialLoading || effects.initialLoading
        || doors.initialLoading || lights.initialLoading) return null;

    return <InitialLoadReady>{children}</InitialLoadReady>;
}
